export default __webpack_public_path__ + "static/media/truck.ba057a44.png";